import React, { useEffect, useState } from "react";
import "./css/MandatoryPublicDisclosure.css";

const MandatoryPublicDisclosure = () => {
  const [generalInformation, setGeneralInformation] = useState([]);
  const [documents_Information, setDocuments_Information] = useState([]);
  const [resultAcademics, setResultAcademics] = useState([]);
  const [resultClassX, setResultClassX] = useState([]);
  const [resultClassXII, setResultClassXII] = useState([]);
  const [staffTeaching, setStaffTeaching] = useState([]);
  const [schoolInfrastructure, setSchoolInfrastructure] = useState([]);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;

  // 1. General Information
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/md_general_information?sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "General Information");
        setGeneralInformation(apiData);
      })
      .catch((error) =>
        console.error("Error fetching general information:", error)
      );
  }, [baseUrl, school]);

  // 2. Documents Information
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/md_documents_information?fields=*,upload_document.*&sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "Documents Information");
        setDocuments_Information(apiData);
      })
      .catch((error) =>
        console.error("Error fetching documents information:", error)
      );
  }, [baseUrl, school]);

  // 3. Result and Academics
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/md_result_and_academics?fields=*,upload_documents.*&sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("jkhgfckjhzf",data);
        
        const apiData = data.data || [];
        console.log(apiData, "Result and Academics");
        setResultAcademics(apiData);
      })
      .catch((error) =>
        console.error("Error fetching result and academics:", error)
      );
  }, [baseUrl, school]);

  // 4. Result Class X
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/result_class_x?sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "Result Class X");
        setResultClassX(apiData);
      })
      .catch((error) =>
        console.error("Error fetching result class X:", error)
      );
  }, [baseUrl, school]);

  // 5. Result Class XII
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/result_class_xii?sort=serail_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "Result Class XII");
        setResultClassXII(apiData);
      })
      .catch((error) =>
        console.error("Error fetching result class XII:", error)
      );
  }, [baseUrl, school]);

  // 6. Staff Teaching
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/staff_teaching?sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "Staff Teaching");
        setStaffTeaching(apiData);
      })
      .catch((error) =>
        console.error("Error fetching staff teaching:", error)
      );
  }, [baseUrl, school]);

  // 7. School Infrastructure
  useEffect(() => {
    fetch(
      `${baseUrl}/${school}/items/school_infrastructure?sort=serial_number`
    )
      .then((response) => response.json())
      .then((data) => {
        const apiData = data.data || [];
        console.log(apiData, "School Infrastructure");
        setSchoolInfrastructure(apiData);
      })
      .catch((error) =>
        console.error("Error fetching school infrastructure:", error)
      );
  }, [baseUrl, school]);

  return (
    <div className="mandatory-disclosure-page">
      <div className="mandatory-container">

        {/* PAGE HEADER */}
        <div className="mandatory-page-header">
          <div className="appendix-title">APPENDIX - IX</div>

          <h1>Mandatory Public Disclosure</h1>

          <div className="header-line"></div>
        </div>

        {/* ================= GENERAL INFORMATION ================= */}
        <section className="disclosure-section">
          <h3>A: GENERAL INFORMATION</h3>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>SL NO.</th>
                  <th>INFORMATION</th>
                  <th>DETAILS</th>
                </tr>
              </thead>

              <tbody>
                {generalInformation.map((item) => (
                  <tr key={item.id}>
                    <td>{item.serial_number}</td>
                    <td>{item.information}</td>
                    <td>{item.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* ================= DOCUMENTS INFORMATION ================= */}
        <section className="disclosure-section">
          <h3>B: DOCUMENTS AND INFORMATION</h3>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>SL NO.</th>
                  <th>DOCUMENTS/INFORMATION</th>
                  <th>UPLOAD DOCUMENTS</th>
                </tr>
              </thead>

              <tbody>
                {documents_Information.map((item) => {
                  const fileId =
                    item.upload_document?.id ||
                    item.upload_document?.data?.id;

                  const fileUrl =
                    item.upload_document?.data?.full_url ||
                    (fileId
                      ? `${baseUrl}/${school}/assets/${fileId}`
                      : null);

                  return (
                    <tr key={item.id}>
                      <td>{item.serial_number}</td>

                      <td>{item.documentsinformation}</td>

                      <td>
                        {fileUrl ? (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="document-link"
                          >
                            VIEW DOCUMENT
                          </a>
                        ) : (
                          <span className="document-link">
                            VIEW DOCUMENT
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* NOTE - KEEP THIS */}
          <div className="disclosure-note">
            <strong>NOTE:</strong> THE SCHOOLS NEEDS TO UPLOAD THE SELF
            ATTESTED COPIES OF ABOVE LISTED DOCUMENTS BY
            CHAIRMAN/MANAGER/SECRETARY AND PRINCIPAL. IN CASE, IT IS
            NOTICED AT LATER STAGE THAT UPLOADED DOCUMENTS ARE NOT
            GENUINE THEN SCHOOL SHALL BE LIABLE FOR ACTION AS PER NORMS.
          </div>
        </section>

        {/* ================= RESULT AND ACADEMICS ================= */}
        <section className="disclosure-section">
          <h3>C: RESULT AND ACADEMICS</h3>

          {/* Result and Academics Documents */}
          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>S.NO.</th>
                  <th>DOCUMENTS/INFORMATION</th>
                  <th>UPLOAD DOCUMENTS</th>
                </tr>
              </thead>

              <tbody>
                {resultAcademics.map((item) => {
                  const fileId =
                    item.upload_documents?.id ||
                    item.upload_documents?.data?.id;
                    
                  const fileUrl =
                    item.upload_documents?.data?.full_url ||
                    (fileId
                      ? `${baseUrl}/${school}/assets/${fileId}`
                      : null);
console.log("filedfzfdUrl",fileUrl);

                  return (
                    <tr key={item.id}>
                      <td>{item.serial_number}</td>
                      <td>{item.documents_information}</td>
                      <td>
                        {fileUrl ? (
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="document-link"
                          >
                            VIEW DOCUMENT
                          </a>
                        ) : (
                          <span className="document-link">
                            VIEW DOCUMENTszfd
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* RESULT CLASS X */}
          <h4>Result Class X</h4>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>S.NO.</th>
                  <th>YEAR</th>
                  <th>NO. OF REGISTERED STUDENTS</th>
                  <th>NO. OF STUDENTS PASSED</th>
                  <th>PASS PERCENTAGE</th>
                  <th>REMARKS</th>
                </tr>
              </thead>

              <tbody>
                {resultClassX.map((item) => (
                  <tr key={item.id}>
                    <td>{item.serial_number}</td>
                    <td>{item.year}</td>
                    <td>{item.no_of_registered_students}</td>
                    <td>{item.no_of_students_passed}</td>
                    <td>{item.pass_percentage}</td>
                    <td>{item.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* RESULT CLASS XII */}
          <h4>Result Class XII</h4>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>S.NO.</th>
                  <th>YEAR</th>
                  <th>NO. OF REGISTERED STUDENTS</th>
                  <th>NO. OF STUDENTS PASSED</th>
                  <th>PASS PERCENTAGE</th>
                  <th>REMARKS</th>
                </tr>
              </thead>

              <tbody>
                {resultClassXII.map((item) => (
                  <tr key={item.id}>
                    <td>{item.serial_number}</td>
                    <td>{item.year}</td>
                    <td>{item.no_of_registered_students}</td>
                    <td>{item.no_of_students_passed}</td>
                    <td>{item.pass_percentage}</td>
                    <td>{item.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* ================= STAFF TEACHING ================= */}
        <section className="disclosure-section">
          <h3>D: STAFF (TEACHING)</h3>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>S.NO.</th>
                  <th>INFORMATION</th>
                  <th>DETAILS</th>
                </tr>
              </thead>

              <tbody>
                {staffTeaching.map((item) => (
                  <tr key={item.id}>
                    <td>{item.serial_number}</td>
                    <td>{item.information}</td>
                    <td>{item.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* ================= SCHOOL INFRASTRUCTURE ================= */}
        <section className="disclosure-section">
          <h3>E: SCHOOL INFRASTRUCTURE</h3>

          <div className="table-wrapper">
            <table className="disclosure-table">
              <thead>
                <tr>
                  <th>S.NO.</th>
                  <th>INFORMATION</th>
                  <th>DETAILS</th>
                </tr>
              </thead>

              <tbody>
                {schoolInfrastructure.map((item) => (
                  <tr key={item.id}>
                    <td>{item.serial_number}</td>
                    <td>{item.information}</td>
                    <td>{item.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

      </div>
    </div>
  );
};

export default MandatoryPublicDisclosure;
